import styled from 'styled-components';


export const Container = styled.div`
  padding: 1rem 4rem 5rem;

  h1 {
    width: 100%;
    text-align: center;
  }
  h2 {
    text-align: left;
    width: 100%;
    padding: 1rem 0;
  }
  span{
    padding: 1rem 0 0 0 ;
  }
  th{
    color: #FFF!important;
  }
  
  `;
  export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`;
export const ContainerInput = styled.div`
  display: flex;
  align-items:center;
  justify-content: flex-start;
  gap:1rem;
  width: 100%;
  margin-bottom: 1rem;
  input{
    width: 100%;
    height: 30px!important;
  }
  button{
    background: var(--color-primary);
    padding: .5rem 1rem;
    border: none;
    border-radius: 5px;
    color: #FFF;
    min-width: 50px;
    align-self: flex-end;
    /* height: 30px; */
    transition: var(--transition);
    &:hover{
      cursor: pointer;
    }
  }
`;